<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入设备模块名"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="()=>{this.queryObj.pageNum = 1;loadModuleList ()}">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>

      <el-select style="float: left;"
                 class="query"
                 size="small"
                 v-model="queryObj.equiTypeId"
                 placeholder="请选择设备类型"
                 clearable
                 filterable
                 @clear="()=>{this.queryObj.pageNum = 1;delete this.queryObj.equiTypeId;}"
                 @change="()=>{this.queryObj.pageNum = 1;loadModuleList ()}">
        <el-option v-for="item in types"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
        </el-option>
      </el-select>
      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>
      <es-delete @del="del()"
                 type="button"></es-delete>
    </div>
    <el-table :data="pageData.list"
              ref="moduleTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="name"
                       label="设备模块名">
      </el-table-column>

      <el-table-column prop="equiTypeName"
                       label="设备类型">
      </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadModuleList()}">
      </es-pagination>
    </div>
    <!--编辑设备模块-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['moduleForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑设备模块
      </span>
      <el-form :model="moduleInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="moduleForm">
        <el-form-item prop="name"
                      label="设备模块名称">
          <el-input v-model="moduleInfo.name"
                    placeholder="请输入设备模块名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>

        <el-form-item prop="equiTypeId"
                      label="设备类型">
          <el-select ref="typeSelect"
                     style="width:200px"
                     size="mini"
                     v-model="moduleInfo.equiTypeId"
                     placeholder="请选择设备类型"
                     clearable
                     filterable>
            <el-option v-for="item in types"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitModule()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'module',
  props: ["funcs"],
  data () {
    return {
      types: [],
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      moduleInfo: {},//设备模块信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入设备模块名称', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ],
        equiTypeId: [
          { required: true, message: '请选择设备类型', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadModuleList()
      this.loadTypeListAll()
    },

    //初始化设备类型下拉框
    loadTypeListAll () {
      this.$ajax.get('/base/assettype/list_all').then(msg => {
        this.types = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    //从后台查询设备模块列表
    loadModuleList () {
      this.loading = true
      this.$ajax.get('/base/module/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加设备模块
    add_init () {
      this.editVisible = true
      this.moduleInfo = {}
    },
    //初始化设备模块
    edit_init (row) {
      this.editVisible = true
      this.moduleInfo = JSON.parse(JSON.stringify(row))
    },
    //保存设备模块
    submitModule () {
      this.$refs["moduleForm"].validate(valid => {
        if (valid) {
          let url = "/base/module/add";
          if (this.moduleInfo.id != null) {
            url = "/base/module/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.moduleInfo).then(msg => {
            this.saving = false
            this.loadModuleList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除设备设备模块
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["moduleTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/module/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadModuleList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
